// Here we specify the default value for the form.

const defaultValues = {
  templateName: "",
  active: "active",
  keywords: [{ value: "" }],
  listSubheader: "Others",
  previewPages: [
    {
      title: "",
      websites: [
        {
          site: "",
        },
      ],
    },
  ],
  country: "Netherlands",
  lastUpdate: "",
  previews: [
    {
      type: "",
      link: "",
      qr: "",
    },
  ],
  downloadFormat: [
    {
      type: "",
      link: "",
    },
  ],
  creatives: [
    {
      creative: "",
      creativeIcon: "desktop",
      mandatory: "true",
      mandatoryAdditionalInfo: "",
      images: [
        {
          url: "",
          website: "",
        },
      ],
      details: [
        {
          title: "",
          infoFields: [
            {
              subject: "",
              text: "",
              type: "text",
              url: "",
            },
          ],
        },
      ],
      adPositions: [
        {
          position: "",
          positionsList: [
            {
              type: "fixedPosition",
              title: "",
              htmlName: "",
              details: [
                {
                  title: "",
                  infoFields: [
                    {
                      subject: "",
                      text: "",
                      type: "text",
                      url: "",
                    },
                  ],
                },
              ],
            },
          ],
          extraInformation: "",
        },
      ],
    },
  ],
};

export default defaultValues;
